// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/acquirenti/:id',
    requestBody: null,
    response: '{"success":true,"data":{"acquirente":"object","commessa":"object","offerta":"object","intervista":"object","appuntamenti":"array","buoni":"array","linkProssimoIncontro":"string"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/percorso-acquirenti/acquirenti/:id/intervista',
    requestBody: '{"usoImmobile":"string","orientamento":"string","haProgettista":"boolean","cucinaGiaScelta":"boolean","stile":"string","note":"string"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/percorso-acquirenti/acquirenti/:id/consegna-buoni',
    requestBody: null,
    response: '{"success":true,"data":{"buoni":"array","emailInviata":"boolean","erroreEmail":"string"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/percorso-acquirenti/appuntamenti/:id/stato',
    requestBody: '{"stato":"string"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/percorso-acquirenti/appuntamenti/:id/reinvia-email',
    requestBody: null,
    response: '{"success":true,"data":{"emailInviata":"boolean"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/acquirenti/:id/slot?da',
    requestBody: null,
    response: '{"success":true,"data":"array"}'
  },
  {
    method: 'POST',
    endpoint: '/api/percorso-acquirenti/acquirenti/:id/appuntamenti',
    requestBody: '{"inizio":"string"}',
    response: '{"success":true,"data":{"id":"number"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
